// src/index.js
import React from "react";
import ReactDOM from "react-dom/client";
import App from "./app/App";                 // <- сюда
import reportWebVitals from "./reportWebVitals";
import { trackWebVital } from "./shared/analytics/googleAnalytics";
import "lineicons/dist/lineicons.css";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

reportWebVitals(trackWebVital);
